import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Route-level authentication guards — evaluated synchronously during render
// (before the protected page ever mounts), so there is no content "flash"
// and no dependence on each page remembering to check storage itself.
// `shopLoggedIn` / `adminLoggedIn` are derived from the non-secret session marker cookie on
// every render (see AuthContext), so this is correct immediately on refresh.

// Guards the Shop-facing storefront: Home, Products, Product Detail, Cart,
// Wishlist, Orders — the entire "main store" surface, including the preview
// root ("/"). Redirects to /login and remembers where the user was headed.
export const RequireShop = ({ children }) => {
  const { shopLoggedIn } = useAuth();
  const location = useLocation();
  if (!shopLoggedIn) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  return children;
};

// Guards the Admin panel AND the CRM panel (both share the same admin/staff
// session token). Redirects to /admin/login and remembers where the user was
// headed so they land back on the right page after signing in.
export const RequireAdmin = ({ children }) => {
  const { adminLoggedIn } = useAuth();
  const location = useLocation();
  if (!adminLoggedIn) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname + location.search }} />;
  }
  return children;
};
